import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CapeVerdeFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14545'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14545)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H20V0H0V7.46667Z'
					fill='#0C49AE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#0C49AE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2667H20V7.46667H0V10.2667Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33336H20V8.40002H0V9.33336Z'
					fill='#CD232E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61886 11.6667C9.19682 11.6667 10.476 10.413 10.476 8.86665C10.476 7.32025 9.19682 6.06665 7.61886 6.06665C6.04091 6.06665 4.76172 7.32025 4.76172 8.86665C4.76172 10.413 6.04091 11.6667 7.61886 11.6667Z'
					stroke='#F7D035'
					strokeWidth='1.33333'
					strokeLinecap='round'
					strokeDasharray='0.67 2'
				/>
			</g>
		</svg>
	);
};

export default CapeVerdeFlagIcon;
